<template>
  <div class="video-label" v-loading.fullscreen.lock="loading">
    <div style="flex: 1; width: calc(100% - 195px)">
      <!-- 视频 -->
      <!-- <video
        ref="videoRef"
        :src="fileUrl"
        playsinline
        style="height: 400px; margin: 0 auto; display: block; width: 100%"
      /> -->
      <div class="video-wrapper">
        <!-- 视频 -->
        <video
          ref="videoRef"
          :src="fileUrl"
          playsinline
          preload="metadata"
          class="video"
          disableRemotePlayback
          disablePictureInPicture
          controlsList="nodownload noremoteplayback"
        />

        <!-- 覆盖层 -->
        <div class="video-mask" @click="togglePlay">
          <div class="play-btn">
            {{ isPlaying ? "❚❚" : "▶" }}
          </div>
        </div>
      </div>
      <!-- <video
        ref="videoRef"
        :src="fileUrl"
        playsinline
        @timeupdate="onTimeUpdate"
        style="height: 400px; margin: 0 auto; display: block; width: 100%"
      /> -->

      <!-- 波形 -->
      <div id="waveform"></div>

      <!-- 区域列表 -->
      <div class="region-list">
        <div
          class="region-item"
          v-for="(item, index) in regionList"
          :key="item.id"
          :style="{ backgroundColor: item.color }"
        >
          <div>{{ index + 1 }}. {{ item.content }}</div>
          <div>
            {{ item.start.toFixed(2) }} - {{ item.end.toFixed(2) }}
            <el-tooltip placement="top-start" trigger="hover" content="播放">
              <el-icon style="cursor: pointer" @click="playRegion(item.region)">
                <VideoPlay />
              </el-icon>
            </el-tooltip>
            <el-tooltip placement="top-start" trigger="hover" content="删除">
              <el-icon
                style="cursor: pointer"
                @click="deleteRegion(item.region)"
                ><Delete
              /></el-icon>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div
        ref="popoverRef"
        class="popover-anchor"
        :style="{ left: menuX + 'px', top: menuY + 'px' }"
      ></div>
      <!-- 右键菜单 -->
      <el-popover
        v-model:visible="popoverVisible"
        :virtual-ref="popoverRef"
        virtual-triggering
        trigger="manual"
        placement="right-start"
        width="120"
      >
        <div class="menu-item" @click="playRegion(clickRegion)">播放</div>
        <div class="menu-item danger" @click="deleteRegion(clickRegion)">
          删除
        </div>
      </el-popover>
    </div>
    <LabelSelect ref="LabelSelectRef" @change="labelChange" />
  </div>
</template>

<script setup>
import { VideoPlay, Delete } from "@element-plus/icons-vue";
import {
  ref,
  onBeforeUnmount,
  getCurrentInstance,
  defineEmits,
  defineExpose,
} from "vue";
import LabelSelect from "./LabelSelect.vue";
import WaveSurfer from "wavesurfer.js";
import RegionsPlugin from "wavesurfer.js/dist/plugins/regions.esm.js";
import TimelinePlugin from "wavesurfer.js/dist/plugins/timeline.esm.js";
import { ElMessage } from "element-plus";
const isPlaying = ref(false);

const togglePlay = () => {
  const video = videoRef.value;

  if (video.paused) {
    video.play();
    isPlaying.value = true;
  } else {
    video.pause();
    isPlaying.value = false;
  }
};
const { proxy } = getCurrentInstance();
const emit = defineEmits(["change"]);
const fileUrl = ref("");
const labelValue = ref(null);
const labelChange = (val) => {
  labelValue.value = val;
};
const loading = ref(false);
const open = async (question, answer) => {
  loading.value = true;
  isPlaying.value = false;
  fileUrl.value = question.url;
  regionList.value = [];

  ws.value && ws.value.destroy();
  initWave();

  const labels = JSON.parse(question.problem);
  proxy.$refs.LabelSelectRef.setOptions(labels);

  ws.value.once("ready", () => {
    if (answer && answer.videoSegments) {
      answer.videoSegments.forEach((item) => {
        const params = labels.find((i) => i.id === item.cls);
        const region = regions.value.addRegion({
          start: item.xmin,
          end: item.xmax,
          content: params.label,
          color: hexToRgba(params.color),
        });
        regionList.value.push({
          id: region.id,
          start: region.start,
          end: region.end,
          params: params,
          content: region.content?.textContent || "",
          color: region.color,
          region,
        });
      });
    }

    // ✅ 回显完成后再关闭
    requestAnimationFrame(() => {
      loading.value = false;
      labelValue.value = null;
    });
  });
};

defineExpose({ open });
const answerChange = () => {
  const res = {
    videoSegments: regionList.value.map((i) => ({
      cls: i.params.id,
      xmin: Number(i.start.toFixed(2)),
      xmax: Number(i.end.toFixed(2)),
    })),
  };
  emit("change", regionList.value.length > 0 ? res : null);
};
/* ================= refs ================= */

const videoRef = ref(null);
const popoverRef = ref(null);

const ws = ref(null);
const regions = ref(null);
const regionList = ref([]);

const popoverVisible = ref(false);
const clickRegion = ref(null);
const menuX = ref(0);
const menuY = ref(0);

/* ================= utils ================= */

const hexToRgba = (hex, alpha = 0.8) => {
  let h = hex.replace("#", "");
  if (h.length === 3) {
    h = h
      .split("")
      .map((c) => c + c)
      .join("");
  }
  const r = parseInt(h.slice(0, 2), 16);
  const g = parseInt(h.slice(2, 4), 16);
  const b = parseInt(h.slice(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

/* ================= init ================= */

const initWave = () => {
  regions.value = RegionsPlugin.create();

  const timeline = TimelinePlugin.create();

  ws.value = WaveSurfer.create({
    container: "#waveform",
    url: fileUrl.value,
    media: videoRef.value,
    minPxPerSec: 10,
    autoScroll: false, // 关键
    autoCenter: false, // 关键
    waveColor: "#c6e2ff",
    progressColor: "#409eff",
    scrollParent: true,
    plugins: [regions.value, timeline],
  });

  regions.value.enableDragSelection({
    color: "rgba(115,118,122,0.4)",
  });

  regions.value.on("region-created", onRegionCreated);
  regions.value.on("region-updated", onRegionUpdated);
  regions.value.on("region-clicked", onRegionClicked);
};

/* ================= region events ================= */
const collectRegion = (region) => {
  if (!region.content?.textContent && labelValue.value) {
    region.setContent(labelValue.value.label);
    region.setOptions({
      color: hexToRgba(labelValue.value.color),
      className: "drag-select-region",
    });
  }

  regionList.value.push({
    id: region.id,
    start: region.start,
    end: region.end,
    params: labelValue.value,
    content: region.content?.textContent || "",
    color: region.color,
    region,
  });

  if (!loading.value) {
    answerChange();
  }
};

const onRegionCreated = (region) => {
  // 初始化 / 回显阶段：不校验
  if (loading.value) {
    // collectRegion(region);
    return;
  }

  // 用户操作阶段：必须选标签
  if (!labelValue.value) {
    region.remove();
    ElMessage.warning("请先选择标签");
    return;
  }

  collectRegion(region);
};

const onRegionUpdated = (region) => {
  const item = regionList.value.find((i) => i.id === region.id);
  if (!item) return;

  item.start = region.start;
  item.end = region.end;

  if (!loading.value) {
    answerChange();
  }
};

const onRegionClicked = (region, e) => {
  e.preventDefault();
  e.stopPropagation();

  clickRegion.value = region;
  menuX.value = e.clientX;
  menuY.value = e.clientY;

  setTimeout(() => {
    popoverVisible.value = true;
  }, 100);
};

/* ================= actions ================= */

const playRegion = (region) => {
  if (!region || !ws.value) return;

  ws.value.pause();
  ws.value.setTime(region.start);
  setTimeout(() => ws.value.play(), 50);

  const handler = (time) => {
    if (time >= region.end) {
      ws.value.pause();
      ws.value.un("audioprocess", handler);
    }
  };
  ws.value.on("audioprocess", handler);
  popoverVisible.value = false;
};

const deleteRegion = (region) => {
  if (!region) return;
  region.remove();
  regionList.value = regionList.value.filter((i) => i.id !== region.id);
  popoverVisible.value = false;

  answerChange();
};

/* ================= lifecycle ================= */

onBeforeUnmount(() => {
  ws.value && ws.value.destroy();
});
</script>

<style scoped lang="less">
.video-wrapper {
  position: relative;
  width: 100%;
  height: 400px;
}

.video {
  width: 100%;
  height: 100%;
  display: block;
  pointer-events: none;
}

/* 蒙层 */
.video-mask {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s;
  cursor: pointer;
}

/* 鼠标移入显示 */
.video-wrapper:hover .video-mask {
  opacity: 1;
}

/* 播放按钮 */
.play-btn {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.video-label {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

video {
  height: 200px;
}

#waveform {
  margin-top: 8px;
  width: 100%;
}

.region-list {
  margin-top: 16px;
  overflow-y: auto;
}

.region-item {
  display: flex;
  justify-content: space-between;
  padding: 8px;
  margin-bottom: 6px;
  color: #000;
}

.menu-item {
  padding: 6px 10px;
  cursor: pointer;
}
.menu-item:hover {
  background: #f5f7fa;
}
.menu-item.danger {
  color: #f56c6c;
}

.popover-anchor {
  position: fixed;
  width: 0;
  height: 0;
}
</style>
